<template>
  <div>
    <notification-bar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      v-if="notification.isLocal === showOnlyLocalNotifications"
    ></notification-bar>
  </div>
</template>

<script>
import { notificationsData } from '@/store/helpers'
import NotificationBar from '@/components/NotificationBar'
export default {
  name: 'NotificationContainer',
  props: {
    showOnlyLocalNotifications: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NotificationBar
  },
  computed: {
    ...notificationsData
  }
}
</script>
